import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'slotsTimeOnly',
  standalone: false
})
export class SlotsTimeOnlyPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return 'NA';

    return value
      .split(',')
      .map(slot => {
        const times = slot.trim().split(' - ');
        return times
          .map(t => t.split(' ')[1])
          .join(' - ');
      })
      .join(', ');
  }
}
